export type MovementDirection = "DEBIT" | "CREDIT" | "ALL";

interface Movement {
	id: string;
	amountCents: number;
	classification: unknown;
	payableObligation: unknown;
	direction: Exclude<MovementDirection, "ALL">;
}

export const Movements = {
	summarize(input: {
		transactions: Movement[];
		direction: MovementDirection;
		inferredClassifications: ReadonlyMap<string, unknown>;
	}) {
		const { transactions, direction, inferredClassifications } = input;
		const scoped = transactions.filter(
			(transaction) => direction === "ALL" || transaction.direction === direction,
		);
		const pending = scoped.filter(
			(transaction) =>
				!transaction.classification &&
				!transaction.payableObligation &&
				!inferredClassifications.has(transaction.id),
		);
		const classified = scoped.filter(
			(transaction) =>
				!!transaction.classification ||
				!!transaction.payableObligation ||
				inferredClassifications.has(transaction.id),
		);

		return {
			totalCount: scoped.length,
			totalAmountCents: scoped.reduce(
				(total, transaction) => total + Math.abs(transaction.amountCents),
				0,
			),
			pendingCount: pending.length,
			pendingAmountCents: pending.reduce(
				(total, transaction) => total + Math.abs(transaction.amountCents),
				0,
			),
			classifiedCount: classified.length,
			classifiedAmountCents: classified.reduce(
				(total, transaction) => total + Math.abs(transaction.amountCents),
				0,
			),
			netAmountCents: scoped.reduce((total, transaction) => total + transaction.amountCents, 0),
		};
	},
};
